module.exports = __webpack_public_path__ + "img/bg_hero_mobile.5da80325.png";